<template>
  <div class="flex" style="gap: 16px">
    <div class="flex align-items-center">
      <RadioButton
        v-model:model-value="v$.value.$model"
        @input="$emit('update:modelValue', $event.target.value)"
        inputId="male"
        name="male"
        value="male"
        v-bind="$attrs"
      />
      <label for="male" class="ml-2">{{ t('general.gender.male') }} </label>
    </div>
    <div class="flex align-items-center">
      <RadioButton
        v-model:model-value="v$.value.$model"
        @input="$emit('update:modelValue', $event.target.value)"
        inputId="female"
        name="female"
        value="female"
        v-bind="$attrs"
      />
      <label for="female" class="ml-2"> {{ t('general.gender.female') }} </label>
    </div>
    <small v-if="v$.value.$error" class="p-error">Gender is required</small>
  </div>
</template>
<script setup>
import { ref, computed } from 'vue'
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { useI18nUtils } from '@/composables/utils/useI18nUtils.js'

const { t } = useI18nUtils()

const props = defineProps({
  modelValue: String,
  label: String,
  required: Boolean
})

const value = ref(props.modelValue)

const rules = computed(() => {
  const v = {}
  if (props.required) {
    v.value = { required }
  } else {
    v.value = {}
  }
  return v
})

const v$ = useVuelidate(rules, { value })
</script>
